"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");exports.__esModule=!0,exports.default=showMultiSelect;var _invoker=_interopRequireDefault(require("./invoker"));function showMultiSelect(e){return _invoker.default.invoke("showMultiSelect",e)}_invoker.default.registerAPI("showMultiSelect",{mini:!0,mobile:!0}),module.exports=exports.default,module.exports.default=exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/gdt-jsapi/showMultiSelect.js
// module id = Uft2
// module chunks = 23